module.exports = __webpack_public_path__ + "static/media/garmin.2c5f7284.svg";